import { buildPanelItem } from "../helpers/buildPanelItem";
import { captureInformationPanel } from "./captureInformation";
import { Label } from "../components/Label";
import { Collapse } from "antd";

export const capturePanel = [
  buildPanelItem(
    "1",
    Label({ label: "status", type: "string" }),
    'The status of the capture can be "healthy", "suspicious", or "unknown", and such an assessment is made according to the device information and geolocation. Both "suspicious" or "unknown" captures lead to "high" risk transactions. Only "healthy" captures lead to "low" risk transactions.',
  ),
  buildPanelItem(
    "2",
    Label({ label: "information", type: "object" }),
    null,
    <Collapse items={captureInformationPanel} />,
  ),
];
